import "regenerator-runtime/runtime";
import * as _ from 'lodash'
export const filterAll = async (products, filters) => {
    return new Promise(async (resolve, reject) => {
        let productsAux = _.cloneDeep(products)
        for (let i = 0; i < filters.length; i++) {
            let prod = _.cloneDeep(productsAux)
            const filter = filters[i];
            productsAux = filter.apply(prod)
        }
        resolve(productsAux)
    })
}